import { r as o } from "./chunk-SYFQ2XB5-BF5IDYrB.js";
const a = (r) => ({
  getRoutes: () => r.redirects.map(({ from: e, to: t }) => ({
    path: e,
    loader: () => o(t, 301)
  }))
});
export {
  a as redirectPlugin
};
//# sourceMappingURL=zudoku.plugin-redirect.js.map
